<rt-views-filter-select
  [filterDef]="filterDef"
  (filterChange)="filterControl.patchValue({ id: $event })"
  class="add-filter"
/>

<rt-select2
  [formControl]="filterControl.controls.condition"
  [items]="conditionOptions"
  [class.full-width]="!filterInputDefs.length || filterInputDefs.length > 2"
  class="condition"
/>

<div [class.hidden]="!filterInputDefs.length" class="inputs">
  <ng-container #inputsRef></ng-container>
</div>
